import { render, staticRenderFns } from "./HistoryScrollList.vue?vue&type=template&id=7251be33"
import script from "./HistoryScrollList.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryScrollList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports